module.exports = __webpack_public_path__ + "img/Group 26583.b4127dfd.png";